<template>

  <div>

    <master-data-form ref="CreateForm" mode="create" :on-update="reload"/>
    <master-data-form ref="UpdateForm" mode="update" :on-update="reload"/>
    <carrier-master-data-form ref="CarrierCreateForm" mode="create" :on-update="reload"/>
    <carrier-master-data-form ref="CarrierUpdateForm" mode="update" :on-update="reload"/>
    <master-data-select-form ref="MasterDataSelectForm" mode="load" :on-update="reload"/>

    <md-card>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-25">
            <auto-complete-select id="MasterGroup"
                    label="Group"
                    :options="getAllMasterGroups"
                    v-model="selectedGroup">
            </auto-complete-select>
          </div>
        <div>
          <span>
            <md-field :class="getValidationClass('DataForm.tagId')">
            <label id="label_tagId">Tag Id</label>
            <md-input id="tagId" ref="tagId" v-model="DataForm.tagId"/>
            </md-field>
          </span>
          <span>
            <md-field :class="getValidationClass('DataForm.destPoint')">
            <label id="label_destPoint">Dest. Point</label>
            <md-input id="destPoint" ref="destPoint" v-model="DataForm.destPoint"/>
            </md-field>
          </span>
          <span>
            <md-field :class="getValidationClass('DataForm.city')">
            <label id="label_city">City</label>
            <md-input id="city" ref="city" v-model="DataForm.city"/>
            </md-field>
          </span>  
          <span>
            <md-field :class="getValidationClass('DataForm.zip')">
            <label id="label_zip">Postal Code</label>
            <md-input id="zip" ref="zip" v-model="DataForm.zip"/>
            </md-field>
          </span>  
        </div>
        <div class="search" style="margin-left:10px;">
          <span>
            <md-field :class="getValidationClass('DataForm.tagName')">
            <label id="label_tagName">Tag Name</label>
            <md-input id="tagName" ref="tagName" v-model="DataForm.tagName"/>
            </md-field>
          </span>
          <span>
            <md-field :class="getValidationClass('DataForm.deptPoint')">
            <label id="label_deptPoint">Dept. Point</label>
            <md-input id="deptPoint" ref="deptPoint" v-model="DataForm.deptPoint"/>
            </md-field>
          </span>
          <span>
            <md-field :class="getValidationClass('DataForm.state')">
            <label id="label_state">State</label>
            <md-input id="state" ref="state" v-model="DataForm.state"/>
            </md-field>
          </span>  
        </div>
        <div class="search" style="margin-left:20px; width:300px;">
           <auto-complete-master-data-multiple-select
               ref="SelectSaleOffice"
               group="GST_SALEOFFICE"
               label="Sale Office"
               :init-selected-ids="searchRequest.salesoffice"
               :on-selected-item-ids-changed="handleSaleOfficeChanged">
           </auto-complete-master-data-multiple-select>
        </div>
        <div class="search2" style="margin-left:100px;">
           <md-button class="btn-search-schedule md-primary md-raised optionExtender" @click="doSearch">Search</md-button>
        </div>
        <div>
           <md-button class="md-raised optionExtender" @click="doClear">Clear</md-button>
        </div>
          <div id="divider" style="width:2px; height:50px;display:inline-block;background-color:light-gray;"></div>
          <div id="carrierSearch">
          </div>  
          <div class="md-layout-item md-size-25">
            <md-checkbox v-model="showOnlyActive">
              <label>Show Only Active Items</label>
            </md-checkbox>
          </div>
          <div>
             
          </div>
          <div style="margin-left:1450px; margin-top: -200px;">
          </div>  
        </div>
      </md-card-content>
    </md-card>
    
    <div>
      <md-button @click="toggleCreate" class="md-fab-bottom-right md-fab md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>

    <br/>

    <calling-api :paths="['/api/w/masterData','api/w/masterData/getGroupList']">

      <pagination :items="getSortedMasterDatas">
        <template slot-scope="{pageItems}">

          <md-card class="data-table-container">
            <div class="outer-container" v-if="isGeneral">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Tag Id</th>
                      <th class="header-cell w15">Tag Name</th>
                      <th class="header-cell w5">Parent Group</th>
                      <th class="header-cell w10">Parent Tag Id</th>
                      <th class="header-cell w2-5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                      <th class="header-cell w5">Sales Office</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w5">{{item.parentGroup}}</td>
                      <td class="body-cell w10">{{item.parentTagId}}</td>
                      <td class="body-cell w2-5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                      <td class="body-cell w5">{{item.saleoffice}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isLocation">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Location Id</th>
                      <th class="header-cell w15">Location</th>
                      <th class="header-cell w15">Street</th>
                      <th class="header-cell w10">City</th>
                      <th class="header-cell w2-5">State</th>
                      <th class="header-cell w5">Postal Code</th>
                      <th class="header-cell w10">Country</th>
                      <th class="header-cell w10">Contact Person</th>
                      <th class="header-cell w10">Contact Tel</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w15">{{item.street}}</td>
                      <td class="body-cell w10">{{item.city}}</td>
                      <td class="body-cell w2-5">{{item.state}}</td>
                      <td class="body-cell w5">{{item.zip}}</td>
                      <td class="body-cell w10">{{item.country}}</td>
                      <td class="body-cell w10">{{item.contactPerson}}</td>
                      <td class="body-cell w10">{{item.contactTel}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isCarrier">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Carrier Id</th>
                      <th class="header-cell w15">Carrier</th>
                      <th class="header-cell w10">SCACODE</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.scacode}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isCustomer">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Customer Id</th>
                      <th class="header-cell w15">Customer Name</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isRoute">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Route Id</th>
                      <th class="header-cell w15">Route Name</th>
                      <th class="header-cell w10">Stage</th>
                      <th class="header-cell w10">Dept. Point</th>
                      <th class="header-cell w10">Dest. Point</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.stage}}</td>
                      <td class="body-cell w10">{{item.deptPoint}}</td>
                      <td class="body-cell w10">{{item.destPoint}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isVendor">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Vendor Id</th>
                      <th class="header-cell w15">Vendor Name</th>
                      <th class="header-cell w10">Valid Until</th>
                      <th class="header-cell w10">Sale Office</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.validPeriod}}</td>
                      <td class="body-cell w10">{{item.saleoffice}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isLease">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Lease Chassis Id</th>
                      <th class="header-cell w15">Lease Chassis Name</th>
                      <th class="header-cell w10">Sale Office</th>
                      <th class="header-cell w10">Vendor</th>
                      <th class="header-cell w10">Equipment Size</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.saleoffice}}</td>
                      <td class="body-cell w10">{{item.vendor}}</td>
                      <td class="body-cell w10">{{item.equipsize}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isRateBill">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Rate Type</th>
                      <th class="header-cell w15">Description</th>
                      <th class="header-cell w10">Measure Unit</th>
                      <th class="header-cell w10">Category</th>
                      <th class="header-cell w10">Container Type</th>
                      <th class="header-cell w10">Customer</th>
                      <th class="header-cell w10">Location</th>
                      <th class="header-cell w10">Sales Office</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.measureUnit}}</td>
                      <td class="body-cell w10">{{item.category}}</td>
                      <td class="body-cell w10">{{item.cntrType}}</td>
                      <td class="body-cell w10">{{item.customer}}</td>
                      <td class="body-cell w10">{{item.location}}</td>
                      <td class="body-cell w10">{{item.salesoffice}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="outer-container" v-if="isRateCost">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Rate Type</th>
                      <th class="header-cell w15">Description</th>
                      <th class="header-cell w10">Measure Unit</th>
                      <th class="header-cell w10">Category</th>
                      <th class="header-cell w10">Container Type</th>
                      <th class="header-cell w10">Customer</th>
                      <th class="header-cell w10">Location</th>
                      <th class="header-cell w10">Sales Office</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.measureUnit}}</td>
                      <td class="body-cell w10">{{item.category}}</td>
                      <td class="body-cell w10">{{item.cntrType}}</td>
                      <td class="body-cell w10">{{item.customer}}</td>
                      <td class="body-cell w10">{{item.location}}</td>
                      <td class="body-cell w10">{{item.salesoffice}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="outer-container" v-if="isScaleMaster">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w10">Group</th>
                      <th class="header-cell w10">Scale code</th>
                      <th class="header-cell w15">Transloading Yard</th>
                      <th class="header-cell w10">Default use</th>
                      <th class="header-cell w10">Receive Window</th>
                      <th class="header-cell w10">Warn Tolerance Time</th>
                      <th class="header-cell w10">Error Tolerance Time</th>
                      <th class="header-cell w5">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w10">{{item.group}}</td>
                      <td class="body-cell w10">{{item.tagId}}</td>
                      <td class="body-cell w15">{{item.tagName}}</td>
                      <td class="body-cell w10">{{item.defaultUse}}</td>
                      <td class="body-cell w10">{{item.recWindow}}</td>
                      <td class="body-cell w10">{{item.warnToleranceTime}}</td>
                      <td class="body-cell w10">{{item.errToleranceTime}}</td>
                      <td class="body-cell w5">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>


          </md-card>

        </template>
      </pagination>
    </calling-api>
  </div>

</template>
<style scoped>
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-size: 23px;
    display: inline-block;
    background-color: lightgray;
    margin-left: 300px;
    margin-top: 15px;
    -moz-osx-font-smoothing: grayscale;
  };
  #divider {
    height: 50px;
    width: 5px;
    background-color: black;
    display: inline-block;
  };
  .optionExtender {
    margin-left: 300px;
  };
  .optionExtender:hover{opacity:0.5};
  .searchTagName {
    margin-top: -15px;
    margin-left: 50px;
    display: inline-block;
  };
  .search {
    margin-left:10px;
  };
  .search2 {
    margin-left:100px;
  };
</style>
<script>
  import MasterDataForm from '../components/MasterDataForm.vue';
  import CarrierMasterDataForm from '../components/CarrierMasterDataForm.vue';
  import MasterDataSelectForm from '../components/MasterDataSelectForm.vue';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    parentGroup: null,
    parentTagId: null,
    active: true,
    scacode: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    contactPerson: null,
    contactTel: null,
    stage: null,
    deptPoint: null,
    destPoint: null,
    saleoffice: null,
    vendor: null,
    validPeriod: null,
    equipsize: null,
    measureUnit: null,
    category: null,
    cntrType: null,
    customer: null,
    location: null,
  });

  const getInitSearchRequest = () => ({
    group: null,
    tagId: null,
    tagName: null,
    parentGroup: null,
    parentTagId: null,
    active: true,
    scacode: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    contactPerson: null,
    contactTel: null,
    stage: null,
    deptPoint: null,
    destPoint: null,
    saleoffice: null,
    vendor: null,
    validPeriod: null,
    equipsize: null,
    measureUnit: null,
    category: null,
    cntrType: null,
    customer: null,
    location: null,
    salesoffices: [],
  });

  export default {
    data: () => ({
      selectedGroup: '',
      saleoffices: [],
      showOnlyActive: true,
      isload: false,
      isGeneral: true,
      isLocation: false,
      isCarrier: false,
      isCustomer: false,
      isRoute: false,
      isVendor: false,
      isLease: false,
      isRateBill: false,
      isRateCost: false,
      isScaleMaster: false,
      masterDatas: [],
      DataForm: getInitialDataForm(),
      searchRequest: getInitSearchRequest(),
      tagId: '',
      masterDataGroups: []
    }),
    components: {
      MasterDataForm,
      CarrierMasterDataForm,
      MasterDataSelectForm,
    },
    computed: {
      ...mapGetters([
        'getSaleOfficeMasterData',
        'getUserProfile'
      ]),
      filteredMasterDatasByActive() {
        if (this.showOnlyActive) {
          return _(this.masterDatas)
            .filter(it => it.active);
        }
        return this.masterDatas;
      },
      getAllMasterGroups() {
        console.log("getAllMasterGroups");
        return _(this.filteredMasterDatasByActive || [])
          .chain()
          .pluck('group')
          .uniq()
          .sortBy(it => it)
          .value();
      },
      getFilteredMasterDatas() {
        //this.isload = false;
        console.log(JSON.stringify(this.searchRequest));
        if (!this.DataForm.tagId)
           this.DataForm.tagId = '';
        if (!this.DataForm.tagName)
           this.DataForm.tagName = '';
        if (!this.DataForm.destPoint)
           this.DataForm.destPoint = '';
        if (!this.DataForm.deptPoint)
           this.DataForm.deptPoint = '';
        if (!this.DataForm.city)
           this.DataForm.city = '';
        if (!this.DataForm.state)
           this.DataForm.state = '';
        if (!this.DataForm.zip)
           this.DataForm.zip = '';
        console.log("getFilteredMasterDatas tagId: " + this.DataForm.tagId);
        console.log("getFilteredMasterDatas tagName: " + this.DataForm.tagName);
        console.log("getFilteredMasterDatas destPoint: " + this.DataForm.destPoint);
        console.log("getFilteredMasterDatas deptPoint: " + this.DataForm.deptPoint);
        console.log("getFilteredMasterDatas state: " + this.DataForm.state);
        console.log("getFilteredMasterDatas zip: " + this.DataForm.zip);

        if (document.getElementById('label_tagId'))
        {
        document.getElementById('label_tagId').innerHTML = "Tag Id";   
        if (this.selectedGroup === 'STC_CARRIER')
          document.getElementById('label_tagId').innerHTML = "Carrier Id";
        if (this.selectedGroup === 'GST_LOCATION')
          document.getElementById('label_tagId').innerHTML = "Location Id";
        if (this.selectedGroup === 'GST_CUSTOMER')
          document.getElementById('label_tagId').innerHTML = "Customer Id";
        if (this.selectedGroup === 'GST_CHASSIS')
          document.getElementById('label_tagId').innerHTML = "Vendor Id";
        if (this.selectedGroup === 'GST_LEASECHASSIS')
          document.getElementById('label_tagId').innerHTML = "Lease Chassis Id";
        if (this.selectedGroup === 'GST_TRUCK')
          document.getElementById('label_tagId').innerHTML = "Truck Id";
        if (this.selectedGroup === 'GST_ROUTE')
          document.getElementById('label_tagId').innerHTML = "Route Id";
        if (this.selectedGroup === 'GST_RATE_BILLING' || this.selectedGroup === 'GST_RATE_COST')
          document.getElementById('label_tagId').innerHTML = "Rate Type";
        if (this.selectedGroup === 'SCALE_MASTER')
          document.getElementById('label_tagId').innerHTML = 'Scale Code';  
        }

        if (document.getElementById('label_tagName'))
        {
        document.getElementById('label_tagName').innerHTML = "Tag Name";   
        if (this.selectedGroup === 'STC_CARRIER')
          document.getElementById('label_tagName').innerHTML = "Carrier Name";
        if (this.selectedGroup === 'GST_LOCATION')
          document.getElementById('label_tagName').innerHTML = "Location Name";
        if (this.selectedGroup === 'GST_CUSTOMER')
          document.getElementById('label_tagName').innerHTML = "Customer Name";
        if (this.selectedGroup === 'GST_CHASSIS')
          document.getElementById('label_tagName').innerHTML = "Vendor Name";
        if (this.selectedGroup === 'GST_LEASECHASSIS')
          document.getElementById('label_tagName').innerHTML = "Lease Chassis Name";
        if (this.selectedGroup === 'GST_TRUCK')
          document.getElementById('label_tagName').innerHTML = "Truck Name";
        if (this.selectedGroup === 'GST_ROUTE')
          document.getElementById('label_tagName').innerHTML = "Route Name";
        if (this.selectedGroup === 'GST_RATE_BILLING' || this.selectedGroup === 'GST_RATE_COST')
          document.getElementById('label_tagName').innerHTML = "Description";
        if (this.selectedGroup === 'SCALE_MASTER')
          document.getElementById('label_tagName').innerHTML = 'Transloading Yard';  
        }
        console.log("getFilteredMasterDatas isLoad: " + this.isload);
        if (this.isload)
        {
          console.log("filter saleoffice: " + this.searchRequest.salesoffices);
          console.log(this.saleoffices);
          if (this.saleoffices.length >= 1)
          {
          return  _(this.filteredMasterDatasByActive)
         .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && ((it.saleoffice !== undefined) && (it.saleoffice != null)
                  && (this.saleoffices.includes(it.saleoffice.toLowerCase()))
                  )
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
                  && (((this.DataForm.destPoint !== '') && ((it.destPoint) && it.destPoint.includes(this.DataForm.destPoint.trim()))) || ((this.DataForm.destPoint === ''))   )
                  && (((this.DataForm.deptPoint !== '') && ((it.deptPoint) && it.deptPoint.includes(this.DataForm.deptPoint.trim()))) || ((this.DataForm.deptPoint === ''))   )
                  && (((this.DataForm.city !== '') && ((it.city) && it.city.includes(this.DataForm.city.trim()))) || ((this.DataForm.city === ''))   )
                  && (((this.DataForm.state !== '') && ((it.state) && it.state.includes(this.DataForm.state.trim()))) || ((this.DataForm.state === ''))   )
                  && (((this.DataForm.zip !== '') && ((it.zip) && it.zip.includes(this.DataForm.zip.trim()))) || ((this.DataForm.zip === ''))   )
            );
          }
          else
          {
           console.log("tagId: " + this.DataForm.tagId.toString());
           console.log("tagName: " + this.DataForm.tagName.trim());
           return  _(this.filteredMasterDatasByActive)
            .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
                  && (((this.DataForm.destPoint !== '') && ((it.destPoint) && it.destPoint.includes(this.DataForm.destPoint.trim()))) || ((this.DataForm.destPoint === ''))   )
                  && (((this.DataForm.deptPoint !== '') && ((it.deptPoint) && it.deptPoint.includes(this.DataForm.deptPoint.trim()))) || ((this.DataForm.deptPoint === ''))   )
                  && (((this.DataForm.city !== '') && ((it.city) && it.city.includes(this.DataForm.city.trim()))) || ((this.DataForm.city === ''))   )
                  && (((this.DataForm.state !== '') && ((it.state) && it.state.includes(this.DataForm.state.trim()))) || ((this.DataForm.state === ''))   )
                  && (((this.DataForm.zip !== '') && ((it.zip) && it.zip.includes(this.DataForm.zip.trim()))) || ((this.DataForm.zip === ''))   )
         
            )
          }             
        }
        else
        {
          console.log("isLoad is false: " + this.isload);
          if (this.selectedGroup)
           return _(this.filteredMasterDatasByActive)
               .filter(it => it.group === this.selectedGroup);
          else
           return _(this.filteredMasterDatasByActive);
        }

      },
      getSortedMasterDatas() {
          return _(this.getFilteredMasterDatas)
            .sortBy(it => it.group);
      },
    },
    watch: {

      selectedGroup() {
        //if (this.isload) {
        switch(this.selectedGroup) {
          case "GST_LOCATION":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = true;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "STC_CARRIER":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = true;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_CUSTOMER":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = true;
               this.isRoute = false;
               this.isVendor =false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_ROUTE":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = true;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_CHASSIS":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = true;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_LEASECHASSIS":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = true;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_RATE_BILLING":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = true,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
             break;
          case "GST_RATE_COST":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = true,
               this.isScaleMaster = false
             });
             break;
          case "SCALE_MASTER":
             this.$nextTick(() => {
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = true
             });
             break;
          default:
             this.$nextTick(() => {
               this.isGeneral = true; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false,
               this.isScaleMaster = false
             });
        }
        //}
        //this.isload = false;
      },
      masterDatas() {
        this.$nextTick(() => {
          this.updateTableHeight();
        });
      },
    },
    async mounted() {
      await this.reload();
    },
    methods: {

      async reload() {
        
        console.log("start reload loading... group list api " + Date());
        console.log("getuserprofile: category - " + this.getUserProfile.category);
        
        var masterdataoffice = "ALL";
        if (this.getUserProfile) {
          if (this.getUserProfile.category === "R" ||
              this.getUserProfile.category === "U" ||
              this.getUserProfile.category === "U1")
              masterdataoffice = "STC";
        }  
        //const grouplist = await api.post('/api/w/masterData/getGroupList',{office: masterdataoffice, active: 1});
        const grouplist = await newAPIPost('/api/w/masterData/getGroupList',{office: masterdataoffice, active: 1});
        var masterDataGroup = [];
        var newMasterDataBatch = [];
        console.log("done getting group info: " + Date())
        console.log("process group load for Master Data " + Date())
        //var masterDataGroupList = JSON.stringify(grouplist).toString();
        $.each( grouplist , function(key, value) {
             value = JSON.stringify(value);
             value = value.toString().substring(value.toString().indexOf(':')+1).replaceAll('"','').replaceAll('}','');
             masterDataGroup.push(value)
        }
        );
        const totalGroups = masterDataGroup.length;
        console.log("grouplist: " + masterDataGroup + " count: " + totalGroups);
        var startindx = 0;
        var portion = totalGroups;
        var lastbatch = 0;
        if (totalGroups > 20)
        {
           portion = parseInt( portion / 20 ,10);
           lastbatch = totalGroups - (portion * 20);
        }
        else
        {
           //portion = parseInt( totalGroups / 20 , 10);
           portion = 0;
           lastbatch = totalGroups;
        }
        var masterDatas = [];
        var endIndx = 0;
        var i;
        console.log("reload portion: " + portion);
        if (portion > 0)
        {
          for (i = 1; i <= portion; i++)
          {
             if ((i * 20) > totalGroups)
             {
                endIndx = (i * 20) - 1;
             }
             else
             {
                endIndx = i * 20;
             }
             console.log("startindx: " + startindx + "i: " + i + " endIndx: " + endIndx);
             //newMasterDataBatch = await api.post('/api/w/masterData',
             newMasterDataBatch = await newAPIPost('/api/w/masterData',
                {groups: masterDataGroup.slice(startindx, endIndx)  }
             );
             startindx = i * 20;
             masterDatas = masterDatas.concat(newMasterDataBatch);
             console.log("startindx after loop: " + startindx);
          }
          if (lastbatch > 0)
          {
             console.log("startindx: " + startindx + " totalGroups: " + totalGroups + " lastbatch: " + lastbatch);
             //newMasterDataBatch = await api.post('/api/w/masterData',
             newMasterDataBatch = await newAPIPost('/api/w/masterData',
              {groups: masterDataGroup.slice(startindx, totalGroups)  }
             );
             masterDatas = masterDatas.concat(newMasterDataBatch);
           
          }
        }
        else
        {
           if (totalGroups > 0)
           {
              console.log("load data with portion less than or equal 0")
              //masterDatas = await api.post('/api/w/masterData',
              masterDatas = await newAPIPost('/api/w/masterData',
                {group: masterDataGroup}
              );
           }
        }

        //add SUPPLIER_US from above since it is too large
        // newMasterDataBatch = await api.post('/api/w/masterData',
        // {groups: ["SUPPLIER_US"]  }
        // );
        console.log("done getting master data: " + Date())
        // masterDatas = masterDatas.concat(newMasterDataBatch);

//        const masterDatas = [];

/*
        const masterDatas = await api.post('/api/w/masterData',
        {groups:[
          "APP_MASTER",
          "SCALE_MASTER",
          "YG_MASTER",
          "UPGRADE_MASTER",
          "WEIGHT_CONTROL",
          "Company",
          "Country",
          "DRIVER_TYPE",
          "GST_CARRIER",
          "GST_CHASSIS",
          "GST_CTNRTYPE",
          "GST_CUSTOMER",
          "GST_DELIVERYTYPE",
          "GST_DO_STATUS",
          "GST_LEASECHASSIS",
          "GST_LIC_TYPE",
          "GST_LOAD_STATUS",
          "GST_LOCATION",
          "GST_MED_TEST_TYPE",
          "GST_RATE_BILLING",
          "GST_RATE_COST",
          "GST_ROUTE",
          "GST_SALEOFFICE",
          "GST_SOURCE",
          "GST_STAGE_STATUS",
          "GST_STAGE_TYPE",
          "GST_STATUS",
          "GST_TERMINAL",
          "GST_TRUCK",
          "UserCategory",
          "Sort",
          "State",
          "REC_WINDOW",
          "DOCKTYPE",
          "INBOUND_STATUS",
          "IBS_TYPE",
          "driverGroup"

          ]}
//            grouplist
          );
*/          
        this.masterDatas = masterDatas;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      toggleCreate() {
        this.$refs.MasterDataSelectForm.openDialog();
      },
      toggleUpdate(item) {
        this.$refs.UpdateForm.openDialog(item);
      },
      doSearch() {
        console.log("reload datagrid");
        console.log(this.DataForm.tagId);
        this.$nextTick(() =>
        this.isload = true);
        //this.isload = true
        
      },
      doClear() {
        this.isload = false;
        console.log("tagId: " + document.getElementById("tagId").innerHTML);
        console.log("tagId value: " + document.getElementById("tagId").value);
        console.log("tagName value: " + document.getElementById("tagName").value);
        console.log("destPoint value: " + document.getElementById("destPoint").value);
        console.log("doClear isload: " + this.isload);
        this.selectedGroup = '';
        this.DataForm.group = null;
        this.DataForm.tagId = null;
        this.DataForm.tagName = null;
        this.DataForm.deptPoint = null;
        this.DataForm.destPoint = null;
        this.DataForm.measureUnit = null;
        this.DataForm.category = null;
        this.DataForm.cntrType = null;
        this.DataForm.customer = null;
        this.DataForm.location = null;
        this.DataForm.saleoffice = null;
        this.saleoffices = [];
        console.log("destPoint value1: " + this.$refs["destPoint"].value);
        this.DataForm = getInitialDataForm();         
        this.searchRequest = getInitSearchRequest();
         _(this.$el.querySelectorAll('button.md-input-action.md-clear')).each((it) => {
           it.click();
         });

        console.log(this.DataForm);
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleSaleOfficeChanged(salesoffice) {
         var indx;
         var tempoffice = [];
         console.log("handlesaleofficechange: " + salesoffice);
         console.log("handleSaleofficechange searchRequest: " + this.searchRequest.salesoffices);
         this.searchRequest.salesoffices = salesoffice;
         tempoffice = this.searchRequest.salesoffices.slice();
         //tempoffice = salesoffice.slice();
         indx = tempoffice.indexOf("GBAL");
         console.log("index: " + indx);
         if (indx > -1)
         {
           console.log("update balrtimore");
           tempoffice[indx] = "balrtimore";
         }  
         indx = tempoffice.indexOf("GBOS");
         console.log("index1: " + indx);
         if (indx > -1)
           tempoffice[indx] = "boston";
         indx = tempoffice.indexOf("GCHI");
         console.log("index2: " + indx);
         if (indx > -1)
           tempoffice[indx] = "chicago";
         indx = tempoffice.indexOf("GLGB");
         console.log("index3: " + indx);
         if (indx > -1)
           tempoffice[indx] = "long beach";
         indx = tempoffice.indexOf("GRUM");
         console.log("index4: " + indx);
         if (indx > -1)
           tempoffice[indx] = "Rumford";
         console.log("handlesaleofficechange1: " + tempoffice);
         this.saleoffices = [];
         this.saleoffices = tempoffice.slice();
         console.log("tempoffice: " + tempoffice);
         console.log("saleoffices: " + this.saleoffices);
         console.log("searchRequest: " + this.searchRequest.salesoffices);
         console.log("End handleSaleOfficeChanged");

      },
    },
  };


</script>
